module.exports = __webpack_public_path__ + "static/media/testCustomerInventory_logo_small.db67e5ec.png";